/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqItem } from '../../models/faq-item';

export interface UpdateFaq$Params {
  id: string;
      body?: FaqItem
}

export function updateFaq(http: HttpClient, rootUrl: string, params: UpdateFaq$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqItem>> {
  const rb = new RequestBuilder(rootUrl, updateFaq.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqItem>;
    })
  );
}

updateFaq.PATH = '/faq/{id}';
